import { Volume2, VolumeX } from 'lucide-react';
import { useBackgroundAudio } from '../contexts/BackgroundAudioContext';
import { useLocation } from 'react-router-dom';

export default function AudioToggle() {
  const { isPlaying, toggleMute } = useBackgroundAudio();
  const location = useLocation();

  // On voice-chat page, position differently to avoid input overlap
  const isChat = location.pathname === '/voice-chat';

  return (
    <button
      onClick={() => toggleMute()}
      className={`fixed z-40 w-9 h-9 rounded-full bg-white/90 shadow-md flex items-center justify-center border border-stone-200/50 active:scale-90 transition-transform ${
        isChat ? 'top-4 left-14' : 'top-4 left-4'
      }`}
      data-testid="audio-toggle"
      style={{ touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}
      title={isPlaying ? 'Mute background' : 'Play background'}
    >
      {isPlaying ? (
        <Volume2 className="w-3.5 h-3.5 text-hunter-green" />
      ) : (
        <VolumeX className="w-3.5 h-3.5 text-warm-charcoal/40" />
      )}
    </button>
  );
}
